import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  onButtonClick: (index: SetStateAction<number>) => void;
}
function ButtonBarComponent(props: IProps) {
  const { t } = useTranslation();
  const [activeButtonIndex, setActiveButtonIndex] = useState(0);
  const buttons = [
    { label: t("buttons.component.favorites"), onClick: () => {} },
    { label: t("buttons.component.requests"), onClick: () => {} },
    { label: t("buttons.component.sons"), onClick: () => {} },
    { label: t("buttons.component.offers"), onClick: () => {} },
    { label: t("buttons.component.privacy"), onClick: () => {} },
  ];
  const handleClick = (index: SetStateAction<number>) => {
    setActiveButtonIndex(index);
    props.onButtonClick(index);
  };
  const { i18n } = useTranslation();
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="max-w-[1326px] w-screen mobile:max-w-[360px] h-16 p-2.5 flex mobile:overflow-x-auto mt-11"
    >
      <div className="items-start gap-6 flex">
        {buttons.map((button, index) => (
          <button
            key={index}
            className={`w-auto px-6 h-11 py-3 flex ${
              activeButtonIndex === index
                ? "bg-mint-500 text-zinc50"
                : "bg-white text-slate-600"
            } rounded-[36px] border border-slate-200 whitespace-nowrap text-base font-arRegular`}
            onClick={() => handleClick(index)}
          >
            {button.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ButtonBarComponent;
